<template>
  <div id="wrapper">
    <el-carousel indicator-position="outside" :height= "bannerHeight + 'px'">
      <el-carousel-item v-for="item in bannerList" :key="item.index">
        <img class="bannerImg" :src="item.urlImg" @load="imgLoad" ref='bannerHeight' />
      </el-carousel-item>
    </el-carousel>
      <div class="contentUnit"></div>
    <div class="industry"></div>
    <div class="nothingness"></div>
    <div class="platformIntroduction"></div>
    <div class="insuranceIntroduced"></div>
    <div class="flowsheet"></div>

    <div class="businessProcess" v-if="loginStatus">
      <div >
        <button type="button" class="button begin" @click="goTo('login')">立即开启对接</button>
      </div>
      <div style="margin-top: 1.5rem">
        <button type="button" class="button login" @click="goTo('login')">已有帐号 立即登录</button>
      </div>
    </div>
    <div class="partner">
      <div style="font-weight: bold;font-size: 1.5rem">合作伙伴</div>
      <div style="color:#999999;line-height:36px;font-style: italic;font-size: 1rem">PARTNERS</div>
      <div style="margin-top:8px;width:100px;border-bottom: 2px solid #E68422;"></div>
      <div class="company">
        <div>
          <img  src="../../static/images/home/company.png"  />
        </div>
      </div>
    </div>
    <el-dialog
      style="margin-left: -100px;width: 500px"
      :visible.sync="textDialog">
      <div style="font-size: 10px;color: black">
        <p style="font-size: 20px;text-align: center;font-weight: bolder;">关于停售“国寿财团体意外保险”产品的公告</p>
        <p>各位尊敬的客户：</p>
        <p>根据《中国银保监会办公厅关于进一步规范保险机构互联网人身保险业务有关事项的通知》（银保监办发〔2021〕108号）相关要求，需对涉及互联网人身险保险产品进行调整，故我公司将自2022年1月1日0时停止销售“国寿财团体意外保险产品”保险产品。</p>
        <p>对于涉及上述产品保险合同，在保险期间届满前，客户仍享有原保险合同约定的相关保障服务，产品停售后将不再接受续保申请。</p>
        <p>如果您有任何疑问，正迅保险经纪有限公司全国统一客服热线020-82526981 竭诚为您服务。</p>

        <p>特此公告。</p>
        <p style="text-align: right;font-weight: bolder;">正迅保险经纪有限公司</p>
        <p style="text-align: right;font-weight: bolder;">2021年12月29日</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import baseUrl from "../tool/baseUrl";

    export default {
      name: "wrapper",
      data() {
        return {
          bannerList: [{"urlImg":"../../static/images/home/banner-1.png"},{"urlImg":"../../static/images/home/banner-2.png"}],
          previewSrcList: ["../../static/images/home/banner-1.png", "../../static/images/home/banner-2.png"],
          bannerHeight: '',
          loginStatus:'',
          textDialog: false
        }
      },
      methods: {
        goTo(title){
          this.current = title;

          if (this.$route.path == '/vue/insureManagement') $('.insuranceList').toggleClass('insure');
          if (title == 'login'){
            if (this.$route.name == 'login') return;
            this.$router.push({name: `${title}`, query: { returnUrl: window.location.href }});
          }else {
            this.$router.push({name: `${title}`});
          }
        },
        imgLoad(){
          this.$nextTick(()=> {
            this.bannerHeight = this.$refs.bannerHeight[0].height;
          })
        }
      },
      mounted() {
        this.imgLoad();
        window.addEventListener('resize', () => {
          this.bannerHeight = this.$refs.bannerHeight[0].height;
          this.imgLoad();
        }, false);
        this.loginStatus = !this.$$.checkLogin();
      }
    }
</script>

<style scoped>
  @import "../../static/css/index.css";
</style>



// WEBPACK FOOTER //
// src/components/index.vue